import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface InsuranceCompany {
    _id: string;
    name: string;
}

interface OrganizationInsurancesResponse {
    insuranceCompanies: Array<InsuranceCompany>;
}

const getOrganizationInsurances = async (sessionId: string): Promise<OrganizationInsurancesResponse> => {
    const { data } = await axios.get(`${API_URL}/insurance/organization`, {
        headers: {
            Authorization: sessionId
        }
    });
    return data;
};

export const useGetOrganizationInsurances = () => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/insurance/organization'],
        queryFn: () => getOrganizationInsurances(sessionContext?.sessionId ?? ''),
        enabled: !!sessionContext?.sessionId,
        staleTime: 1000 * 60 * 60,
        refetchOnMount: false
    });
};
